import { createHooksActions, createHooksSelectors } from 'src/helpers/redux'
import * as store from 'src/store/modules/presence'

export { store }

export * from 'src/store/modules/presence/state'

export const usePresenceSelect = createHooksSelectors<
  typeof store.selectors.selectors
>(store.selectors.selectors)

export const usePresenceAction = createHooksActions<typeof store.actions>(
  store.actions,
  store.selectors.communications
)
